import { Service } from '@angular/core';

@Service()
export class ScrollBarService {
    refDivScroll: HTMLDivElement;
}
